/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useEventData from '../../../state/event/UseEventData';

const useEventMultiSelect = (filterIds, isRelay=false) => {
  const { eventState, getEvents } = useEventData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (eventState.isArrayLoading === false && eventState.isArrayLoaded === false) {
      getEvents();
    } else if (eventState.isArrayLoading === false && eventState.isArrayLoaded === true) {
      const eventOptions = [];
      const filterIdArray = filterIds && filterIds.length > 0 ? filterIds.split(',').map(id => parseInt(id)) : [];

      for (const event of eventState.arrayData) {
        if (event.eventId > 0 && 
          (filterIdArray.length === 0 || filterIdArray.includes(event.courseId)) && 
          event.isRelay === isRelay &&
          event.distance <= 1650 && event.courseId !== 4) {
          eventOptions.push({ id: event.eventId, name: event.eventName });
        }
      }

      setOptions(eventOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventState, filterIds, isRelay]);

  return {
    eventState,
    options
  };
};

export default useEventMultiSelect;